import { render, staticRenderFns } from "./TkRightArrow.vue?vue&type=template&id=f1a5041a&"
import script from "./TkRightArrow.vue?vue&type=script&lang=js&"
export * from "./TkRightArrow.vue?vue&type=script&lang=js&"
import style0 from "./TkRightArrow.vue?vue&type=style&index=0&id=f1a5041a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports